import * as React from 'react'

import { AmpYoutube } from '@thg-commerce/gravity-amp'

import { GenericEmbedProps } from './types'
import { EmbedWrapper } from './style'

interface YouTubeProps extends GenericEmbedProps {
  title?: string
}

export const YouTube = (props: YouTubeProps) => {
  const parseYouTubeUrl = (url: string) => {
    const regex = /^.*(youtu\.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\/”"'\&\?]*).*/
    const match = url.match(regex)
    if (match && match[2].length === 11) {
      return match[2]
    }
    return ''
  }
  const videoId = parseYouTubeUrl(props.url)

  if (props.isAmp) {
    return (
      <AmpYoutube
        width={props.width || '480'}
        height={props.height || '270'}
        layout="responsive"
        data-videoid={videoId}
      />
    )
  }

  const iframeSrc = `//youtube.com/embed/${videoId}?autoplay=0`

  return (
    <EmbedWrapper>
      <iframe
        title={props.title || 'YouTube Video'}
        src={iframeSrc}
        frameBorder="0"
        width={props.width || '640px'}
        height={props.height || '390px'}
        allow="accelerometer; encrypted-media; gyroscope; picture-in-picture"
        allowFullScreen
        tabIndex={0}
      ></iframe>
    </EmbedWrapper>
  )
}
